import { alpha } from "@mui/material/styles";
import type { SxProps, Theme } from "@mui/material/styles";

type AuthStatusCardOptions = {
  textAlign?: "left" | "center";
};

export const authStatusPageSx: SxProps<Theme> = {
  minHeight: { xs: "calc(100vh - 120px)", md: "calc(100vh - 140px)" },
  display: "grid",
  placeItems: "center",
  width: "100%",
  bgcolor: "background.default",
  px: { xs: 2, md: 3 },
  py: { xs: 4, md: 6 },
};

export const routeLoadingPageSx: SxProps<Theme> = {
  ...authStatusPageSx,
  px: 0,
};

export const getAuthStatusCardSx =
  ({ textAlign }: AuthStatusCardOptions = {}): SxProps<Theme> =>
  (theme) => ({
    width: "min(100%, 520px)",
    border: 1,
    borderColor: "divider",
    borderRadius: 3,
    p: { xs: 3, md: 4 },
    bgcolor: "background.paper",
    boxShadow: `0 20px 56px ${alpha(theme.palette.common.black, 0.12)}`,
    ...(textAlign ? { textAlign } : {}),
  });

export const authStatusIconSx: SxProps<Theme> = (theme) => ({
  width: 52,
  height: 52,
  borderRadius: "50%",
  display: "grid",
  placeItems: "center",
  color: theme.palette.primary.main,
  bgcolor: alpha(theme.palette.primary.main, 0.1),
  boxShadow: `inset 0 0 0 1px ${alpha(theme.palette.primary.main, 0.08)}`,
});

export const authStatusContentSx: SxProps<Theme> = {
  alignItems: "center",
  textAlign: "center",
};

export const authStatusProgressSx: SxProps<Theme> = (theme) => ({
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 999,
  px: 2,
  py: 1,
  color: "text.secondary",
  bgcolor: alpha(theme.palette.primary.main, 0.06),
});

export const authStatusActionsSx: SxProps<Theme> = {
  justifyContent: "center",
  width: "100%",
};

export const authStatusPrimaryButtonSx: SxProps<Theme> = {
  minWidth: 150,
  borderRadius: 999,
  color: "#fff",
  bgcolor: "primary.main",
  "&:hover": {
    bgcolor: "primary.dark",
  },
};

export const authStatusSecondaryButtonSx: SxProps<Theme> = {
  minWidth: 150,
  borderRadius: 999,
  color: "text.primary",
  bgcolor: "transparent",
  borderColor: "primary.light",
  "&:hover": {
    bgcolor: "action.hover",
    borderColor: "primary.main",
  },
};

export const authStatusHelperSx: SxProps<Theme> = {
  maxWidth: 420,
  mx: "auto",
};
